import {Env} from "@morningtrain/helpers";

export default class EnvRepositoryAdapter {

    get(query, defaultValue = null) {
        return Env.get(query, defaultValue);
    }

    load() {
        return Promise.resolve();
    }

};